import styled from 'styled-components';

import { Portal } from 'components/Portal/Portal';
import { Body } from 'components/Text/Body';
import { H2 } from 'components/Text/H2';
import { Modal } from 'modals/Modal';

type Props = {
  onClose: () => void;
  jobTitle: string;
  jobDescription?: string;
};

export const ModalWrapper = styled.div`
  margin-top: 10px;
`;

export const Description = styled(Body)`
  *:last-child {
    margin-bottom: 0;
  }

  ul {
    padding-left: 24px;
    list-style-type: none;

    li {
      position: relative;

      &::before {
        content: '•';
        position: absolute;
        right: 100%;
        width: 24px;
        text-align: left;
      }
    }
  }
`;

export function TitleDescriptionModal({
  onClose,
  jobTitle,
  jobDescription,
}: Props) {
  return (
    <Portal>
      <Modal wide onClose={onClose} data-qa-id="title-description-modal">
        <ModalWrapper>
          <H2>{jobTitle}</H2>
          {jobDescription && (
            <Description
              dangerouslySetInnerHTML={{
                __html: jobDescription,
              }}
            />
          )}
        </ModalWrapper>
      </Modal>
    </Portal>
  );
}
